import React from 'react';

import moment from 'moment';
import 'moment/locale/es';
import { Checkbox, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
const FormItem = Form.Item;

moment.locale();

class FormIndicadoresRiesgo extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let valor = this.evaluarPuntaje(values);

        let respuestas = {
          ...values,
          valor,
        };

        // console.log(this.props);
        this.props.onSubmit(respuestas);
      }
    });
  };

  evaluarPuntaje = respuestas => {
    // console.log("Entre a evaluar el puntaje con....");
    // console.log(respuestas);

    let valor = 0;
    //Lo que busco a continuacion es sumar los valores, pero como estan en STRINGS, primero debo aplicar el operador UNARIO + para convertirlos a INT.

    if (respuestas.signosAgresion) {
      valor = valor + 3;
    }

    if (respuestas.intervencionMedica) {
      valor = valor + 3;
    }

    if (respuestas.amenazaMuerte) {
      valor = valor + 2;
    }

    if (respuestas.presenciaArmas) {
      valor = valor + 4;
    }

    if (respuestas.abortoProvocado) {
      valor = valor + 4;
    }

    if (respuestas.intentosSuicidio) {
      valor = valor + 3;
    }

    if (respuestas.discapacidad) {
      valor = valor + 2;
    }

    // console.log("El resultado es.... ", valor);

    return valor;
  };

  render() {
    moment.locale();
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Evaluación Indicadores de Riesgo Fisico</h1>

        <Form onSubmit={this.handleSubmit} className="formulariosViolencia">
          {' '}
          <FormItem {...formItemLayout} label="Signos de agresión">
            {getFieldDecorator('signosAgresion', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Intervención medica">
            {getFieldDecorator('intervencionMedica', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Amenaza de muerte">
            {getFieldDecorator('amenazaMuerte', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Presencia de armas">
            {getFieldDecorator('presenciaArmas', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Aborto provocado por agresor">
            {getFieldDecorator('abortoProvocado', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Intentos de suicidio">
            {getFieldDecorator('intentosSuicidio', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Discapacidad">
            {getFieldDecorator('discapacidad', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button style={{ margin: 10 }} type="primary" htmlType="submit">
              Siguiente
            </Button>
            <Button
              style={{ margin: 10 }}
              type="danger"
              onClick={this.props.onCancel}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormIndicadoresRiesgo);
